<template>
    <div>
        <div class="muven-card">
            <div class="muven-card-title">
                <p>
                    Pedidos em aberto

                    <router-link 
                        class="btn btn-outline-secondary btn-sm float-right"
                        :to="orderListWithFilter">
                        <fa icon="external-link-alt" />
                    </router-link>
                </p>
            </div>

            <div>
                <highcharts :options="pendingOrdersChartOptions" ref="chart"/>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts'
import router from '@/router'
import dashboardService from '@/dashboard/services/DashboardService'
import {createGraphic} from '@/utils/normalizers/GraphicNormalizer'
import {dateTimeFilter} from '@/utils/filters/DateTimeFilter'
import {simpleCurrencyFilter} from '@/utils/filters/SimpleCurrencyFilter'
import {differenceInDays} from '@/utils/helpers/DateHelper'
import {sum} from 'lodash'
import { dangerColor } from '../constants/Color'
import { OrderStatusEnum } from '@c2b/muven-commons'

export default {
    name: 'PendingOrdersCmp',
    data() {
        return {
            orderListWithFilter: `/pedidos?custom=true&statusList=${OrderStatusEnum.Pending},${OrderStatusEnum.Approved},${OrderStatusEnum.Billed},${OrderStatusEnum.Posted},${OrderStatusEnum.Delivered},${OrderStatusEnum.PendingAssignments},${OrderStatusEnum.Integrating},${OrderStatusEnum.Error}`,
            pendingList: [],
            pendingOrdersChartOptions: createGraphic({
                chart: {
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    margin: 0,
                    height: 300
                },
                tooltip: {
                    formatter() {
                        return `
                            ${this.point.pendingOrder.description}: <b>${this.point.pendingOrder.total}</b> pedidos
                        `   
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                        startAngle: -90,
                        endAngle: 90,
                        center: ['50%', '65%'],
                        size: '100%'
                    },
                },
                legend: {
                    enabled: true,
                },
                series: [
                    {
                        innerSize: '72%',
                        data: [],
                    }
                ]
            }),
        }
    },
    async mounted() {
        this.pendingList = await dashboardService.getPendingOrders()

        this.$refs.chart.chart.series[0].setData(this.pendingList.map((p, index) => {
            return {
                color: index === 0 ? dangerColor : Highcharts.getOptions().colors[index],
                y: p.total,
                name: p.description,
                pendingOrder: {
                    ...p,
                },
            }
        }))  

        this.$refs.chart.chart.setTitle({            
            text: `<div class="muven-donut-total">
                <span class="muven-donut-total-label">Total</span>
                <span class="muven-donut-total-value">${sum(this.pendingList.map((p) => p.total))}</span>
            </div>`,
            useHTML: true,
            align: 'center',
            verticalAlign: 'middle',
            y: 40,
        })
    },
}
</script>
